<script setup lang="ts">
import { useSession } from '../stores/session'
const session = useSession()
</script>

<template>
  <div class="pointer-events-none fixed right-4 bottom-4 left-4 z-50 flex flex-col items-end gap-2" aria-live="polite">
    <div
      v-for="t in session.toasts"
      :key="t.id"
      class="mono pointer-events-auto max-w-sm border px-4 py-3 text-[12px] shadow-[0_8px_24px_rgba(0,0,0,0.4)]"
      :class="t.kind === 'error' ? 'border-signal bg-signal text-white' : 'border-ink bg-ink text-paper'"
      role="status"
    >
      {{ t.text }}
    </div>
  </div>
</template>
